import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";

const LinkButton = (props) => {
  const {
    history,
    staticContext,
    to,
    onClick,
    valid,
    // ⬆ filtering out props that `button` doesn’t know what to do with.
    ...rest
  } = props;

  const timerRef = useRef();

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return (
    <button
      {...rest} // `children` is just another prop!
      onClick={(event) => {
        onClick && onClick(event);
      }}
    />
  );
};

export default withRouter(LinkButton);
